import routePaths from "../routePaths";
import appUserRoles from "../app/appUserRoles";

const accessPages = {
  [appUserRoles.Admin]: Object.values(routePaths),
  [appUserRoles.FleetManager]: [
    routePaths.FLEET_MANAGEMENT,
    routePaths.NOTIFICATIONS,
    routePaths.NOTIFICATIONS_CREATE,
    routePaths.NOTIFICATIONS_EDIT
  ],
  [appUserRoles.ApplicationManager]: [
    routePaths.APPS,
    routePaths.CREATE_APP,
    routePaths.CONSENTS,
    routePaths.CONSENTS_CONSENT_ELEMENTS,
    routePaths.CONSENT_ELEMENT_CREATE,
    routePaths.CONSENT_ELEMENT_EDIT,
    routePaths.USERS,
    routePaths.USERS_CREATE,
    routePaths.USERS_EDIT,
    routePaths.DASHBOARD,
    routePaths.NOTIFICATIONS,
    routePaths.NOTIFICATIONS_CREATE,
    routePaths.NOTIFICATIONS_EDIT
  ],
  [appUserRoles.MarketAdmin]: [routePaths.DASHBOARD],
  [appUserRoles.ContentManager]: [
    routePaths.APPS,
    routePaths.CREATE_APP,
    routePaths.CONSENTS,
    routePaths.CONSENTS_CONSENT_ELEMENTS,
    routePaths.CONSENT_ELEMENT_CREATE,
    routePaths.CONSENT_ELEMENT_EDIT,
    routePaths.NOTIFICATIONS,
    routePaths.NOTIFICATIONS_CREATE,
    routePaths.NOTIFICATIONS_EDIT
  ],
  [appUserRoles.Reporter]: [routePaths.DASHBOARD]
};

export default accessPages;
